import React from 'react';
import { BookXIcon, ListChecksIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function DifferenceSection() {
  return <section className="w-full bg-navy py-16 sm:py-24" aria-label="Why this is different" data-id="element-103" data-mp="1p20bn6bqu9h3">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-104" data-mp="1k246h3rb8bzy">
        <SectionHeading title={<>
              Why this is different from a <span className="text-volt" data-id="element-106" data-mp="1y0lsmx1khgfr">traditional electrical manual</span>
            </>} data-id="element-105" data-mp="1k4qdn2aagphn" />

        <div className="mt-12 grid gap-8 md:grid-cols-2 md:gap-10" data-id="element-107" data-mp="1tyqntikfgkx8">
          <div className="flex gap-4" data-id="element-108" data-mp="27qwxqmwzlvo8">
            <BookXIcon className="h-8 w-8 shrink-0 text-mist" aria-hidden="true" data-id="element-109" data-mp="27u2o05hcr3lj" />
            <div data-id="element-110" data-mp="22v83mz3ql6zb">
              <h3 className="font-display text-2xl font-bold uppercase text-mist" data-id="element-111" data-mp="2hqfd0q1yct9y">Most resources</h3>
              <p className="mt-2 text-base leading-relaxed text-mist" data-id="element-112" data-mp="2crb6k76ex9nb">
                Explain electrical concepts — hundreds of pages of disconnected theory you have to translate
                into action yourself.
              </p>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-113" data-mp="2kr0h2rj73wzc">
            <ListChecksIcon className="h-8 w-8 shrink-0 text-volt" aria-hidden="true" data-id="element-114" data-mp="2oslovygvhl2o" />
            <div data-id="element-115" data-mp="2trf7g5b0o29p">
              <h3 className="font-display text-2xl font-bold uppercase text-white" data-id="element-116" data-mp="2trye2pv7v48f">This blueprint</h3>
              <p className="mt-2 text-base leading-relaxed text-white" data-id="element-117" data-mp="2yr1kadmxnghz">
                Focuses on applying a diagnostic process: practical tools organized around the decisions
                technicians encounter during battery drain investigations. Every volume is built around
                workflows, checklists, decision trees, and documentation templates.
              </p>
            </div>
          </div>
        </div>

        <blockquote className="mx-auto mt-12 max-w-3xl border-y border-line py-8 text-center font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-118" data-mp="3hic4kby5kv0w">
          Less searching through theory. <span className="text-volt" data-id="element-119" data-mp="1mee93ccgjr6i">More structured diagnostic action.</span>
        </blockquote>

        <SectionCta label="Start diagnosing with structure" data-id="element-120" data-mp="1hgl1qfzf4r4n" />
      </div>
    </section>;
}